import React from "react";
import EmergencyBanner from "@/components/EmergencyBanner";
import Header from "@/components/Header";
import Hero from "@/components/sections/Hero";
import Vision from "@/components/sections/Vision";
import Rituel from "@/components/sections/Rituel";
import Ateliers from "@/components/sections/Ateliers";
import Transmission from "@/components/sections/Transmission";
import Incubateur from "@/components/sections/Incubateur";
import Espaces from "@/components/sections/Espaces";
import Galerie from "@/components/sections/Galerie";
import Application from "@/components/sections/Application";
import Donation from "@/components/sections/Donation";
import Engagement from "@/components/sections/Engagement";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="bg-[#FAF7F2] text-[#2C1E23] overflow-x-hidden">
      <EmergencyBanner />
      <Header />
      <Hero />
      <Vision />
      <Rituel />
      <Ateliers />
      <Transmission />
      <Incubateur />
      <Espaces />
      <Galerie />
      <Application />
      <Donation />
      <Engagement />
      <Contact />
      <Footer />
    </main>
  );
}
